import { useMemo } from 'react';

import SFilter from '@/features/StructuredFilter/class/SFilter';
import useInsightExplorerStore from '@/stores/InsightExplorerStore';
import { FeedbackSentiment } from '@/types/feedbackConst';
import { FEEDBACK_COLUMNS, SENTIMENT_COLUMNS } from '@/types/filterKeyConst';
import { STRUCTURED_FILTER_OPERATOR } from '@/types/structuredFilterConst';
import { isEmptyString } from '@/utils/util';

import {
  InsightExplorerByType,
  InsightExplorerViewType,
} from '../types/constants';

const useWordCloudPayload = () => {
  const { filterQueryFormats, searchValue, dateState, selectedNode, view } =
    useInsightExplorerStore();

  const getFilterKeyFromBy = (by: InsightExplorerByType): string => {
    switch (by) {
      case InsightExplorerByType.TAXONOMY:
        return FEEDBACK_COLUMNS.TAXONOMY;
      case InsightExplorerByType.TAXONOMY_TOPIC:
        return FEEDBACK_COLUMNS.TAXONOMY_TOPIC;
      case InsightExplorerByType.TAG:
        return FEEDBACK_COLUMNS.TAG;
      default:
        throw new Error('Invalid by');
    }
  };

  const filterPayload = useMemo(() => {
    if (!selectedNode) return {};
    const filterKey = getFilterKeyFromBy(selectedNode.node_type);
    const sFilter = new SFilter();
    sFilter.addFilterQueryFormats(filterQueryFormats);
    sFilter.setValueSet(filterKey, [
      {
        op: STRUCTURED_FILTER_OPERATOR.OR,
        values: [selectedNode.id],
      },
    ]);

    if (view === InsightExplorerViewType.SENTIMENTS) {
      sFilter.setValueSet(SENTIMENT_COLUMNS.SENTIMENT_DETAIL, [
        {
          op: STRUCTURED_FILTER_OPERATOR.OR,
          values: [FeedbackSentiment.NEGATIVE],
        },
      ]);
    }

    if (!isEmptyString(searchValue)) {
      sFilter.setIncludeSnippetFilter({
        op: STRUCTURED_FILTER_OPERATOR.OR,
        values: [searchValue],
      });
    }

    sFilter.setDateFilter({
      start_date: dateState.dateRange[0].toJSON(),
      end_date: dateState.dateRange[1].toJSON(),
    });

    return sFilter.get() || {};
  }, [
    JSON.stringify(filterQueryFormats),
    dateState,
    searchValue,
    view,
    selectedNode,
  ]);

  return filterPayload;
};

export default useWordCloudPayload;
